module.exports = __webpack_public_path__ + "static/Graphik-Regular-Cy-Web-bcd0dafeead9dc9ffdbc9dd243fe736f.woff2";